/* PW Cards — card shows: countdowns, month calendar, "add to calendar" (.ics). Used by
   sections/pwc-shows.liquid (Shows page) and sections/pwc-next-show.liquid (home strip). */
(function () {
  'use strict';
  if (window.__pwShows) return;
  window.__pwShows = true;

  var DAY = 86400000;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function parse(s) {
    var p = String(s || '').split('-');
    return p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2]) : null;
  }
  function today() {
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function key(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  // "Today!", "Tomorrow", "In 5 days", "In 3 weeks", "On now" for multi-day shows
  function countdown(el) {
    var start = parse(el.dataset.date);
    var end = parse(el.dataset.end) || start;
    var out = el.querySelector('[data-pw-countdown]');
    if (!start || !out) return;
    var t = today();
    var days = Math.round((start - t) / DAY);
    var label = '';
    if (t >= start && t <= end) label = start - end === 0 ? 'Today!' : 'On now';
    else if (days === 1) label = 'Tomorrow';
    else if (days > 1 && days < 14) label = 'In ' + days + ' days';
    else if (days >= 14 && days < 60) label = 'In ' + Math.round(days / 7) + ' weeks';
    if (!label) return;
    out.textContent = label;
    out.hidden = false;
    if (days <= 1) out.classList.add('is-soon');
  }

  function ics(show) {
    var start = parse(show.dataset.date);
    var end = new Date(+(parse(show.dataset.end) || start) + DAY);
    var f = function (d) { return key(d).replace(/-/g, ''); };
    var esc = function (s) { return String(s || '').replace(/[\\;,]/g, '\\$&'); };
    var body = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//PW Cards//Shows//EN', 'BEGIN:VEVENT',
      'UID:' + (show.id || 'pw-show') + '@pwcards.com',
      'DTSTAMP:' + new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z',
      'DTSTART;VALUE=DATE:' + f(start), 'DTEND;VALUE=DATE:' + f(end),
      'SUMMARY:' + esc(show.dataset.name + ' - PW Cards'),
      'LOCATION:' + esc(show.dataset.place),
      'DESCRIPTION:' + esc('Come say hi at the PW Cards table! ' + location.origin + '/pages/shows'),
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    var a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
    a.download = (show.dataset.name || 'show').replace(/[^\w]+/g, '-').toLowerCase() + '.ics';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  function calendar(root) {
    var dataEl = document.querySelector('[data-pw-shows-data]');
    if (!dataEl) return;
    var shows;
    try { shows = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byDay = {};
    shows.forEach(function (s) {
      var d = parse(s.d), e = parse(s.e) || d;
      for (var x = new Date(d); x <= e; x = new Date(+x + DAY)) (byDay[key(x)] = byDay[key(x)] || []).push(s);
    });
    var first = parse(shows[0] && shows[0].d) || today();
    var view = new Date(first.getFullYear(), first.getMonth(), 1);
    var min = new Date(today().getFullYear(), today().getMonth(), 1);
    var lastShow = parse(shows[shows.length - 1].e) || first;
    var max = new Date(lastShow.getFullYear(), lastShow.getMonth() + 2, 1);
    var grid = root.querySelector('[data-pw-cal-grid]');
    var title = root.querySelector('[data-pw-cal-title]');
    var prev = root.querySelector('[data-pw-cal-prev]');
    var next = root.querySelector('[data-pw-cal-next]');

    function draw(dir) {
      title.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
      var lead = (view.getDay() + 6) % 7; // Monday first
      var count = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      var t = key(today());
      var html = '';
      for (var i = 0; i < lead; i++) html += '<span class="pw-cal__pad"></span>';
      for (var d = 1; d <= count; d++) {
        var k = key(new Date(view.getFullYear(), view.getMonth(), d));
        var hit = byDay[k];
        var cls = 'pw-cal__day' + (k === t ? ' is-today' : '') + (k < t ? ' is-past' : '');
        if (hit) {
          var mine = hit.filter(function (s) { return s.o; })[0];
          html += '<button type="button" class="' + cls + ' has-show' + (mine ? ' is-ours' : '') + '" data-h="' + (mine || hit[0]).h + '" aria-label="' + d + ' ' +
            MONTHS[view.getMonth()] + ': ' + hit.map(function (s) { return s.n; }).join(', ').replace(/"/g, '&quot;') + '">' + d + '</button>';
        } else {
          html += '<span class="' + cls + '">' + d + '</span>';
        }
      }
      grid.innerHTML = html;
      grid.classList.remove('is-left', 'is-right');
      if (dir) { void grid.offsetWidth; grid.classList.add(dir > 0 ? 'is-right' : 'is-left'); }
      prev.disabled = view <= min;
      next.disabled = view >= max;
    }
    prev.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); draw(-1); });
    next.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); draw(1); });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-h]');
      if (!b) return;
      var card = document.getElementById('show-' + b.dataset.h);
      if (!card) return;
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      card.classList.remove('is-flash');
      void card.offsetWidth;
      card.classList.add('is-flash');
    });
    // Swipe between months on phones
    var sx = null;
    grid.addEventListener('pointerdown', function (e) { sx = e.clientX; }, { passive: true });
    grid.addEventListener('pointerup', function (e) {
      if (sx == null) return;
      var dx = e.clientX - sx;
      sx = null;
      if (Math.abs(dx) < 40) return;
      (dx < 0 ? next : prev).click();
    });
    draw(0);
  }

  function boot() {
    document.querySelectorAll('[data-pw-show]').forEach(countdown);
    document.querySelectorAll('[data-pw-cal]').forEach(calendar);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pw-ics]');
      if (b) {
        ics(b.closest('[data-pw-show]'));
        b.closest('details') && b.closest('details').removeAttribute('open');
        return;
      }
      // Close an open "Add to calendar" menu when tapping elsewhere
      document.querySelectorAll('.pw-show__cal[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    // Arriving from the home page strip: flash the show you tapped
    if (location.hash.indexOf('#show-') === 0) {
      var el = document.getElementById(location.hash.slice(1));
      if (el) el.classList.add('is-flash');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
